$(document).ready(function () {
  $('.hero-slider__images').slick({
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 800,
    fade: true,
    cssEase: 'linear'
  });
});